module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Chart-pie-0aa09ae88385aea46636932bff9b98af.svg";